import React, { useContext, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react";
import { AuthContext } from "Context/AuthContext";

import closeIcon from "../../Assets/popup/cross-square.svg";
import { toast } from "react-toastify";
import axios from "axios";
import { PopUpContext } from "Context/PopUpContext";
import { useNavigate } from "react-router-dom"

export default function LeaveProjectModal({
  isOpen,
  onClose,
  stopClosePropagation,
  frondId,
  flag,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showUnassignDialog, setShowUnassignDialog] = useState(false);
  const [assignedTaskCount, setAssignedTaskCount] = useState(0);

  const { user } = useContext(AuthContext);
  const userId = user?.id;
  const authToken = localStorage.getItem("token");
  const { setIsShareProject } = useContext(PopUpContext);
  const navigate = useNavigate();

  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  };

  const fetchProjectTasksWithUserId = async (projectId) => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast("No auth token found. Please log in again.", { type: "error" });
      return [];
    }

    try {
      const response = await axios.get(
        `/projects/${projectId}/tasks`,
        {
          headers: getAuthHeaders(),
          params: { 
            user_id: userId
          }
        }
      );

      return response.data?.response?.data || [];
      console.log("Fetched tasks with user_id:", response.data?.response?.data);
    } catch (error) {
      console.error(
        "Failed to fetch project tasks:",
        error.response?.data || error.message
      );
      return [];
    }
  };

  const handleClose = () => {
    setShowUnassignDialog(false);
    setAssignedTaskCount(0);
    setIsLoading(false);
    setIsDisabled(false);
    onClose();
  };

  const checkTasksAndLeave = async () => {
    setIsLoading(true);
    setIsDisabled(true);

    if (!frondId) {
      setIsLoading(false);
      setIsDisabled(false);
      return;
    }

    try {
      // Check for assigned tasks with user_id parameter
      const tasks = await fetchProjectTasksWithUserId(frondId);
      const taskCount = tasks.length;
      setAssignedTaskCount(taskCount);

      if (taskCount > 0) {
        setShowUnassignDialog(true);
      } else {
        await performLeaveProject();
      }

    } catch (error) {
      toast(error?.response?.data?.message || "Failed to check tasks.", {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
    
    setIsLoading(false);
    setIsDisabled(false);
  };

  const performLeaveProject = async () => {
    try {
      await axios.post(
        `/projects/${frondId}/leave`,
        {},
        {
          headers: getAuthHeaders()
        }
      );
      
      handleClose();
      setIsShareProject(true);
      setTimeout(() => setIsShareProject(false), 1000);
      toast("You've now left the project", {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast success-toast",
      });
      if (flag) navigate("/shared-fronds");
    } catch (error) {
      toast(error?.response?.data?.message, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
  };

  const getProjectOwnerIdFromTasks = (tasks) => {
    if (!tasks || tasks.length === 0) {
      console.log("No tasks found to extract project owner ID");
      return null;
    }
    
    // Get the owner ID from the first task (all tasks should have the same project owner)
    const ownerId = tasks[0]?.owner?.id;
    console.log("Project Owner ID extracted from tasks:", ownerId);
    
    return ownerId;
  };

const handleUnassignAndLeave = async () => {
  setIsLoading(true);
  setIsDisabled(true);

  try {
    // Directly call backend leave API
    await performLeaveProject();
  } catch (error) {
    console.error("Error leaving project:", error.response?.data || error.message);

    if (error.response?.status === 401) {
      toast("Your session has expired. Please log in again.", { type: "error" });
    } else {
      toast("Failed to leave project. Please try again.", { type: "error" });
    }
  } finally {
    setIsLoading(false);
    setIsDisabled(false);
  }
};


  return (
    <>
      {/* First Modal - Leave Confirmation */}
      <Modal
        isOpen={isOpen && !showUnassignDialog}
        onOpenChange={handleClose}
        placement="center"
        backdrop="opaque"
        classNames={{
          backdrop: "z-[9999]",
          wrapper: "z-[99999]",
          footer: "justify-center items-center py-5",
          body: "border-b-1 border-solid border-grayBorder pt-2 pb-4",
          closeButton: "hidden",
          base: "p-5 confirm-modal",
        }}
        hideCloseButton={true}
        onClick={(e) => e.stopPropagation()}
      >
        <ModalContent>
          <ModalHeader className="flex items-center justify-end">
            <button onClick={handleClose} className="" aria-label="Close">
              <img src={closeIcon} alt="Close" className="w-6 h-6" />
            </button>
          </ModalHeader>
          <ModalBody>
            <p className="text-cardGrayColor font-bold text-center leading-[18.4px] sm:w-[256px] mx-auto">
              Are you sure you want to leave this project?
            </p>
          </ModalBody>
          <ModalFooter className="flex items-center justify-center gap-2.5">
            <button
              onClick={handleClose}
              className="text-base font-bold leading-[18.4px] flex justify-center items-center rounded-[27px] py-[11px] px-[25px] w-[100px] h-[39px] gradiantBorder no-focus smallBorder"
            >
              <span className="text-base font-normal text-transparent bg-mainGradiant bg-clip-text">
                Cancel
              </span>
            </button>
            <button
              disabled={isDisabled}
              onClick={checkTasksAndLeave}
              className="text-base font-bold leading-[18.4px] text-white flex justify-center items-center bg-mainGradiant rounded-[27px] py-[11px] px-[25px] w-[100px] h-[39px]"
            >
              {isLoading ? (
                <span className="flex items-center justify-center gap-2 text-white">
                  <i className="fa-solid fa-spinner fa-spin"></i>
                </span>
              ) : (
                "Leave"
              )}
            </button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Second Modal - Unassign Confirmation */}
      <Modal
        isOpen={showUnassignDialog}
        onOpenChange={() => setShowUnassignDialog(false)}
        placement="center"
        backdrop="opaque"
        classNames={{
          backdrop: "z-[10000]",
          wrapper: "z-[100000]",
          footer: "justify-center items-center py-5",
          body: "border-b-1 border-solid border-grayBorder pt-2 pb-4",
          closeButton: "hidden",
          base: "p-5 confirm-modal",
        }}
        hideCloseButton={true}
        onClick={(e) => e.stopPropagation()}
      >
        <ModalContent>
          <ModalHeader className="flex items-center justify-end">
            <button onClick={() => setShowUnassignDialog(false)} className="" aria-label="Close">
              <img src={closeIcon} alt="Close" className="w-6 h-6" />
            </button>
          </ModalHeader>
          <ModalBody>
            <p className="text-cardGrayColor font-bold text-center leading-[18.4px] sm:w-[256px] mx-auto">
              You have {assignedTaskCount} task(s) assigned to you in this project.
              These tasks will be reassigned to the project owner before you leave.
            </p>
          </ModalBody>
          <ModalFooter className="flex items-center justify-center gap-2.5">
            <button
              onClick={() => setShowUnassignDialog(false)}
              className="text-base font-bold leading-[18.4px] flex justify-center items-center rounded-[27px] py-[11px] px-[25px] w-[100px] h-[39px] gradiantBorder no-focus smallBorder"
            >
              <span className="text-base font-normal text-transparent bg-mainGradiant bg-clip-text">
                Cancel
              </span>
            </button>
            <button
              disabled={isDisabled}
              onClick={handleUnassignAndLeave}
              className="text-base font-bold leading-[18.4px] text-white flex justify-center items-center bg-mainGradiant rounded-[27px] py-[11px] px-[25px] h-[39px]"
            >
              {isLoading ? (
                <span className="flex items-center justify-center gap-2 text-white">
                  <i className="fa-solid fa-spinner fa-spin"></i>
                </span>
              ) : (
                "Reassign & Leave"
              )}
            </button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}